module.exports = __webpack_public_path__ + "static/media/aboutme.b45a454f.png";